<template>
<div id="charge-coupon">
  <!-- v-model="showChargeCoupon"
  :visible.sync="showChargeCoupon"
   -->
  <el-dialog
    v-model="value"
    top="50%"
    custom-class="charge-coupon-modal"
    :close-on-click-modal="false">

    <div class="charge-coupon-box">
       <img
        class="customer-img"
        v-if="chargeCouponData.popStyle && chargeCouponData.imgUrl"
        :src="chargeCouponData.imgUrl"
        @click="goAccount()"
      />
      <div class="default-charge" v-else>
        <img class="out-bg" src="https://o.666visa.cn/static/ssqwxa/global/charge-coupon/recharge-out-bg-pc.png" />
        <img class="top-bg" src="https://o.666visa.cn/static/ssqwxa/global/charge-coupon/recharge-top-bg-pc.png" />
        <div class="charge-title">{{chargeCouponData.activityTitle}}</div>
        <div class="charge-subtitle" v-if="chargeCouponData.activityTime">活动时间 {{chargeCouponData.activityTime}}</div>
        <div class="coupon-list">
          <div class="charge-coupon-item" v-for="(item, index) in chargeCouponData.chargeData" :key="index">
            <div class="discount-mark">限时折扣</div>
            <div class="charge-coupon-list-top">
              <div class="price-box">
                <div class="label">充</div>
                <div class="unit">￥</div>
                <div >{{item.recharge_amount / 100}}</div>
              </div>
              
            </div>
            <div class="charge-coupon-list-footer">
              <div v-if="item.show_type === 2">送{{item.min_discount / 1000}}折优惠券</div>
              <div v-else-if="item.show_type === 1">送{{item.total_reduce / 100}}元优惠券</div>
            </div>
          </div>
        </div>
        <div class="footer-box">
          <div class="recharge-btn" @click="goAccount()">去充值</div>
        </div>
      </div>

      <div class="close-btn" @click="closechargeCoupon()">
        <img src="../../assets/imgs/coupon/modal-close.png" class="close-modal" />
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import defaultImg from '../../assets/imgs/coupon/charge-coupon-background.png';

export default {
  name: 'charge-coupon',
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 充值赠送优惠券数据
    chargeCouponData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultImg, // 默认背景图
      showChargeCoupon: this.value, // 是否展示
    };
  },
  computed: {
  },
  watch: {
  },

  methods: {
    // 关闭
    closechargeCoupon() {
      this.$emit('input', false);

      const chargeCouponActivity = {};
      chargeCouponActivity[this.chargeCouponData.activityID] = true;
      localStorage.setItem('chargeCouponActivity', JSON.stringify(chargeCouponActivity));
    },

    // 跳转到充值页面
    goAccount() {
      this.$emit('input', false);
      this.$router.push({ name: 'balance', query: { page_from: '首页-充值弹窗' } });

      const chargeCouponActivity = {};
      chargeCouponActivity[this.chargeCouponData.activityID] = true;
      localStorage.setItem('chargeCouponActivity', JSON.stringify(chargeCouponActivity));
    },
  },

};
</script>

<style lang="less">
#charge-coupon {
  .charge-coupon-modal {
    transform: translate(-50%,-50%);
    width: 440px;
    // box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.2);
    box-shadow: none;
	  background: transparent;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      .charge-coupon-box {
        position: relative;
        display: flex;
        justify-content: center;
        .customer-img{
          width: 440px;
          height: 540px;
          cursor: pointer;
          border-radius: 17px;
        }
        .default-charge{
          width: 100%;
          position: relative;
          background: linear-gradient(0deg, #FFFFFF 0%, #FFFFFF 81%, #FED3C9 100%) #fff;
          border-radius: 17px;
          padding: 30px;
          .out-bg{
            width: 576px;
            height: 180px;
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
          }
          .top-bg{
            width: 100%;
            height: 120px;
            position: absolute;
            left: 0;
            top: -56px;
          }
          .charge-title{
            text-align: center;
            color: #2F333D;
            font-size: 32px;
            font-weight: 600;
            line-height: 44px;
            letter-spacing: 4px;
          }

          .charge-subtitle{
            text-align: center;
            margin-top: 5px;
            color: #999;
            font-size: 16px;
          }

          .coupon-list{
            margin-top: 30px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-right: -16px;
            margin-bottom: -16px;
            .charge-coupon-item{
              position: relative;
              margin-right: 16px;
              margin-bottom: 16px;
              width: 182px;
              height: 133px;
              background: url(https://o.666visa.cn/static/ssqwxa/global/charge-coupon/recharge-item-bg-pc.png) no-repeat center / 100% 100%;
              .discount-mark{
                position: absolute;
                left: 0;
                top: 0;
                width: 86px;
                height: 22px;
                background: linear-gradient( 270deg, #FA6279 0%, #F43344 100%);
                border-radius: 9px 0px 14px 0px;
                display: flex;
                align-items: center;
                color: #fff;
                font-size: 16px;
                font-weight: 500;
                padding-left: 8px;
                box-sizing: border-box;
              }
              .charge-coupon-list-top{
                width: 100%;
                height: 86px;
                padding-top: 30px;
                
                .price-box{
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #2F333D;
                  font-weight: 600;
                  line-height: 1;
                  font-size: 40px;
                  .label{
                    margin-top: 12px;
                    margin-right: 2px;
                    font-size: 16px;
                    color: rgba(89, 89, 97, 1);
                  }
                  .unit{
                    margin-top: 12px;
                    font-size: 18px;
                  }
                }
                
              }
              .charge-coupon-list-footer{
                width: 100%;
                height: 46px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #F43344;
                font-size: 16px;
              }
            }
          }


          .footer-box{
            margin-top: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            .recharge-btn{
              width: 214px;
              height: 60px;
              background: url(https://o.666visa.cn/static/ssqwxa/global/charge-coupon/recharge-btn-pc.png) no-repeat center / 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 24px;
              cursor: pointer;
            }
          }
        }

        
        
        .close-btn {
          position: absolute;
          bottom: -81px;
          left: 0;
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: 0;
          cursor: pointer;
          img {
            width: 36px;
            height: 36px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/charge-coupon.vue